import { render, staticRenderFns } from "./editVehicleDetails.vue?vue&type=template&id=2ec24173"
import script from "./editVehicleDetails.vue?vue&type=script&lang=js"
export * from "./editVehicleDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports